import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from '@cld/theme-helper';

/**
 * Returns the actual value of the provided spacing constant from theme or 0 if not provided.
 * @param {string} propName name of the prop with spacing value to resolve
 */
const resolveSpacing = (propName) => (props) => (props[propName] ? theme`spacing.${propName}`(props) : 0);
const resolveHorizontalMargin = (props) => resolveSpacing('horizontalMargin')(props);
const resolveVerticalMargin = (props) => resolveSpacing('verticalMargin')(props);

const SeparatorPropTypes = {
  horizontalMargin: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  verticalMargin: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
};

export const HorizontalSeparator = styled.div`
  height: 1px;
  width: calc(100% - 2 * ${resolveHorizontalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${theme`palette.secondary`};
`;
HorizontalSeparator.propTypes = SeparatorPropTypes;

export const VerticalSeparator = styled.div`
  width: 1px;
  height: calc(100% - 2 * ${resolveVerticalMargin});
  margin: ${resolveVerticalMargin} ${resolveHorizontalMargin};
  background-color: ${theme`palette.secondary`};
`;
VerticalSeparator.propTypes = SeparatorPropTypes;
